exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1FmUYOKKjx5-ZPiGPY3bnf{fill:\"[theme:neutralPrimary, default:#333333]\"}._11JSsiSAw9Ayy16vAEdqfI{cursor:pointer!important}.oYlxX2G4wIobg87dDrcwT{width:100%;height:100%}", ""]);
// Exports
exports.locals = {
	"icon": "_1FmUYOKKjx5-ZPiGPY3bnf",
	"card": "_11JSsiSAw9Ayy16vAEdqfI",
	"image": "oYlxX2G4wIobg87dDrcwT"
};